import { EpimsBaseEntityDto } from './epim-base.dto';
export class LessorAreaMakerDto extends EpimsBaseEntityDto {
  LessorAreaMakerId: string;
  LessorAreaMakerDesc: string;
  LessorAreaMakerLat: number;
  LessorAreaMakerLong: number;
  LessorAreaMakerNorthing: number;
  LessorAreaMakerEasting: number;
  LessorAreaMakerRemarks: string;
  LandTitleId: string;
  AddressBookId: string;
  PobLatitudeDegree: number;
  PobLatitudeMin: number;
  PobLatitudeSec: number;
  PobLongitudeDegree: number;
  PobLongitudeMin: number;
  PobLongitudeSec: number;
}
